import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";
import { queryJoinUs } from "@/strapiQuery/joinUs";
import { JoinUsContent } from "@/components/pages/joinUs/JoinUsPage";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );

  const joinUsPageContentPromise = getStrapiEntity<JoinUsContent>(
    "nous-rejoindre",
    queryJoinUs
  );

  const [layout, joinUsPageContent] = await Promise.all([
    layoutPromise,
    joinUsPageContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      reviewsConst,
      intlMessages,
      ...joinUsPageContent,
      defaultCanonicalRoute: routes.joinUs,
    },
    revalidate: 10,
  };
};

export { JoinUs as default } from "@/components/pages/joinUs/JoinUsPage";
